import { LoadingCards } from '@eventbrite/eds-event-card';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import { Header } from '../../components/Header';
import { Subtitle } from '../../components/Subtitle';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';

export type TopActivitiesLoadingProps = {
    title: GenericLazyString | string;
    subtitle: GenericLazyString | string;
};

const TopActivitiesLoading = ({
    title,
    subtitle,
}: TopActivitiesLoadingProps) => {
    return (
        <ThingsToDoSection>
            <Header title={title} />
            <Subtitle text={subtitle} />
            <div className="event-card--container loading">
                <LoadingCards cardCount={8} style="grid" />
            </div>
        </ThingsToDoSection>
    );
};

export default TopActivitiesLoading;
